import type { EditorJsData } from '../../editorjs-types';

/** Strip simple inline tags Editor.js may store in header text. */
export function stripEditorInlineMarkup(text: string): string {
  return text.replace(/<[^>]+>/g, '').trim();
}

/**
 * True when the first header block in reading order starts with `Files:`
 * (Wikipedia-style files section title).
 */
export function editorDataHasLeadingFilesSection(
  data: EditorJsData | null,
): boolean {
  if (!data?.blocks?.length) return false;

  for (const block of data.blocks) {
    if (block.type !== 'header') continue;

    const raw =
      block.data &&
      typeof block.data === 'object' &&
      'text' in block.data &&
      typeof (block.data as { text?: unknown }).text === 'string'
        ? (block.data as { text: string }).text
        : '';
    const text = stripEditorInlineMarkup(raw);
    return text.startsWith('Files:');
  }
  return false;
}
